"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCustomerListCsvFilename = getCustomerListCsvFilename;
const tz_1 = require("@date-fns/tz");
const date_fns_1 = require("date-fns");
function getCustomerListCsvFilename({ filename, keyPrefix, }) {
    const formattedDate = (0, date_fns_1.format)(new Date(), 'yyyy-MM-dd_HHmm', {
        in: (0, tz_1.tz)('Europe/Berlin'),
    });
    return `${keyPrefix}${formattedDate}_${filename}`;
}
//# sourceMappingURL=get-customer-list-csv-filename.js.map